export async function getUsers (searchQuery = '') {
    const params = {};

    if (searchQuery) {
        params['q'] = searchQuery;
    }

    const res = await axios.get('/team-members', { params });

    return res.data.data.map((user) => {
        return {
            id: `@${user.display_name ?? user.name}`,
            userId: user.id_hash,
            name: user.display_name ?? user.name,
            avatar: user.avatar_src,
        };
    });
}
